import React from 'react';
import Svg from '@svg/index';
import { Subtext } from '@ui-library/typography';
import { RudderstackLogo } from '@ui-library/brandLogo';
import { Button } from '@ui-library/button';
import { Flex } from '@ui-library/flex';
import { useTheme } from 'styled-components';
import { PageContainer, CopyContainer, Hero } from './styles';

interface ErrorPageProps {
  /** Shows a "Log out" button next to "Reload", for an error that a reload does not fix. */
  onLogOut?: () => void;
  isLoggingOut?: boolean;
}

export const ErrorPage = ({ onLogOut, isLoggingOut = false }: ErrorPageProps) => {
  const { token } = useTheme();
  return (
    <PageContainer
      data-testid="error-page"
      flexDirection="column"
      justifyContent="space-between"
      flexGrow
      alignItemsCenter
    >
      <CopyContainer
        gap=".5em"
        flexDirection="column"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <RudderstackLogo size={30} />
        <Hero className="m-t-lg">Sorry about this...</Hero>
        <Subtext color={token.colorTextDescription} className="m-t-sm m-b-lg">
          Something went wrong loading this page. Let's try again.
        </Subtext>
        <Flex gap=".5em">
          <Button onClick={() => window.location.reload()}>Reload</Button>
          {onLogOut && (
            <Button type="secondary" loading={isLoggingOut} onClick={onLogOut}>
              Log out
            </Button>
          )}
        </Flex>
      </CopyContainer>
      <Svg name="error-page-bg-image" />
    </PageContainer>
  );
};
